module.exports = __webpack_public_path__ + "static/media/imagery-bg.8dc615cf.png";